import request from "@/plugins/axios";

export default {
  syncCompInfo(params) {
    return request.get(`/Crm/Data/SyncComp`, { params });
  },
  CheckSyncDataIsComplete() {
    return request.get(`/Crm/Data/CheckSyncDataIsComplete?syncType=1`);
  },
  getAllDepartmentTree() {
    return request.get(`/Crm/Department/DepartmentTree`);
  },
  getDepartmentTree(pId) {
    return request.get(`/Crm/Department/DepartmentTree?pId=${pId}`);
  },
  getCompUserList(params) {
    return request.get(`/Crm/User/UserList`, { params });
  },
  getCompRoleList() {
    return request.get(`/Crm/Role/RoleList`);
  },
  addUserRole(data) {
    return request.post(`/Crm/User/AddUserRole`, data);
  },
  getLeaderList(deptId) {
    return request.get(`/Crm/User/LeaderList?deptId=${deptId}`);
  },
};
